import React from 'react';
import { GroupedRawIngredient } from '../../store/selectors/rawIngredientsSelectors';

interface RawIngredientGroupRowProps {
  group: GroupedRawIngredient;
  isExpanded: boolean;
  onToggle: () => void;
}

export const RawIngredientGroupRow: React.FC<RawIngredientGroupRowProps> = ({
  group,
  isExpanded,
  onToggle
}) => {
  return (
    <tr
      onClick={onToggle}
      style={{
        backgroundColor: '#f8f9fa',
        borderBottom: '2px solid #e0e0e0',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
      }}
      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#e9ecef')}
      onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
    >
      <td
        style={{
          padding: '16px',
          fontWeight: '700',
          color: '#333',
          fontSize: '15px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span
            style={{
              fontSize: '14px',
              color: '#666',
              transition: 'transform 0.2s',
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
              display: 'inline-block'
            }}
          >
            ▶
          </span>
          {group.ingredientName || '(unnamed)'}
        </div>
      </td>
      <td
        style={{
          padding: '16px',
          fontWeight: '600',
          color: '#666',
          fontSize: '14px'
        }}
      >
        {group.lotCount === 1 ? '1 lot' : `${group.lotCount} lots`}
      </td>
      <td
        style={{
          padding: '16px',
          fontWeight: '600',
          color: '#666',
          fontSize: '14px'
        }}
      >
        {group.unitSize || '-'}
      </td>
      <td
        style={{
          padding: '16px',
          textAlign: 'center',
          fontSize: '18px',
          fontWeight: '700',
          color: '#4CAF50'
        }}
      >
        {group.totalQuantity.toFixed(2)}
      </td>
      <td
        style={{
          padding: '16px',
          textAlign: 'center',
          fontWeight: '500',
          color: '#999',
          fontSize: '13px'
        }}
      >
        {isExpanded ? 'Collapse' : 'Expand'}
      </td>
    </tr>
  );
};
